import { Row, Col } from 'antd';
import React, { useState } from 'react';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import ImageGallery from 'react-image-gallery';
import './styles.less';
import './image-gallery-styles.scss';
import { category_list, image_categories } from '../../common/image_categories';

export const HotelImageGallery = ({ data, photoRef }) => {

    const [selectedCategory, setSelectedCategory] = useState('');
    const [isImageCrouselFullScreen, setIsImageCrouselFullScreen] = useState(false);
    const breakpoints = useBreakpoint();

    function getSmallImage(image) {
        if (image.sizes) {
            if (image.sizes["1080"]) return image.sizes["1080"].href
            else if (image.sizes["800"]) return image.sizes["800"].href
            else if (image.sizes["2160"]) return image.sizes["2160"].href
            else if (image.sizes["320"]) return image.sizes["320"].href
            else return '';
        }
        else {
            console.log(image);
            return '';
        }
    }

    function getCrouselImageHeight() {
        return isImageCrouselFullScreen ? window.screen.height : breakpoints.md ? 440 : 385;
    }

    return (
        <div
            id='hotel-details-img-gallery'
            className='mb-5'
        >
            <h3 id='photos' ref={photoRef} className='mb-3'>Pictures</h3>
            <Row id="image-gallery"
                gutter={[16, 16]}
            >
                <Col
                    xs={24}
                    md={4}
                    className={`d-flex ${breakpoints.md ? 'flex-column align-items-center' : 'flex-row align-items-center flex-nowrap'} image-category-container`}
                    style={{
                        borderRadius: '10px',
                        border: '2px solid #d3e6f8',
                        overflowY: breakpoints.md ? 'auto' : 'hidden',
                        overflowX: breakpoints.md ? 'hidden' : 'auto',
                        height: breakpoints.md ? '440px' : '55px',
                    }}
                >
                    <div
                        style={{
                            backgroundColor: selectedCategory === '' ? '#0081ff' : 'white',
                            minHeight: '55px',
                            minWidth: breakpoints.md ? '100%' : 'fit-content',
                            borderBottom: breakpoints.md ? '1px #d3e6f8 solid' : 'none'
                        }}
                        className='d-flex align-items-center justify-content-center pointer px-3 px-md-0'
                        onClick={() => setSelectedCategory('')}
                    >
                        <p
                            className={`m-2 fw-bold text-center ${selectedCategory === '' ? 'text-white' : '#595959'}`}
                        >
                            All
                        </p>
                    </div>

                    {
                        category_list.filter(e => data.images.find(i => i.category === e)).map(e => (
                            <div
                                style={{
                                    minWidth: breakpoints.md ? '100%' : 'fit-content',
                                    backgroundColor: selectedCategory === e ? '#0081ff' : 'white',
                                    minHeight: '55px',
                                    borderBottom: breakpoints.md ? '1px #d3e6f8 solid' : 'none'
                                }}
                                className='d-flex align-items-center justify-content-center pointer px-3 px-md-0'
                                onClick={() => setSelectedCategory(e)}
                            >
                                <p
                                    key={e}
                                    className={`m-2 fw-bold text-center ${selectedCategory === e ? 'text-white' : '#595959'}`}
                                >
                                    {image_categories[e]}
                                </p>
                            </div>

                        ))
                    }
                </Col>
                <Col
                    xs={24}
                    md={20}
                >
                    <ImageGallery
                        items={
                            (selectedCategory ? data.images.filter(i => i.category === selectedCategory) : data.images).map((e, i) => ({
                                original: getSmallImage(e),
                                thumbnail: getSmallImage(e),
                                originalAlt: e.baseName,
                                thumbnailAlt: e.baseName,
                                originalHeight: getCrouselImageHeight(),
                                originalClass: 'image-gallery-image',
                                thumbnailClass: 'image-gallery-thumbnail'
                            }))
                        }
                        showPlayButton={false}
                        thumbnailPosition={
                            breakpoints.md ? 'right' : 'bottom'
                        }
                        onScreenChange={(e) => setIsImageCrouselFullScreen(e)}
                    />

                </Col>
            </Row >
        </div>
    )
}
